import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {CloudflareService} from "../../websites/website/booster/services/cloudflare.service";
import {LoadWebsiteBandwidth} from "../actions";
import * as bandwidthActions from '../actions/bandwidth.action';

@Injectable()
export class BandwidthEffects {

  loadWebsiteBandwidth$ = createEffect(() => this._actions$.pipe(
    ofType(bandwidthActions.LOAD_WEBSITE_BANDWIDTH),
    mergeMap((action: LoadWebsiteBandwidth) => {
      return this._cloudflareService.getWebsiteCDNBandwidth(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new bandwidthActions.LoadWebsiteBandwidthSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new bandwidthActions.LoadWebsiteBandwidthFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _cloudflareService: CloudflareService
  ) {
  }


}
